var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app",
    [
      _c("ticket-app-title-bar"),
      _c(
        "v-main",
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "v-fade-transition",
                {
                  attrs: {
                    appear: "",
                    "hide-on-leave": "",
                    "leave-absolute": "",
                  },
                },
                [
                  _c("router-view", {
                    key: "site-router",
                    attrs: { name: "default" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }